import { getBookingSuccessType } from "../../../APIDocs/apiTypes"
import { SiteAddressCard } from "./jobDetails/SiteAddressCard";
import { useDefinedParams } from "../hooks/useDefinedParams";
import { SiteContactCard } from "./jobDetails/SiteContactCard";
import { useStoreBooking } from "../hooks/useStoreBooking";
import { useNav } from "../hooks/useNav";
import { useNavigate, useLocation } from "react-router-dom";
import { BookingDetailsCard } from "./jobDetails/BookingDetailsCard";
import { FieldDetailsCard } from "./jobDetails/FieldDetailsCard";
import { UpdateDetailsCard } from "./jobDetails/UpdateDetailsCard";
import { CancellationDetailsCard } from "./jobDetails/CancellationDetailsCard";
import { KeyJobDetailsCard } from "./jobDetails/KeyJobDetailsCard";
import { useCanAccess } from "../hooks/useUserPermissions";
import { EditJob } from "./EditJob";
import { RebookJob } from "./RebookJob";
import { CancelJobButton } from "./CancelJobButton";


export const Job = () => {

    const [bookingId, mpan, serviceLine, contractId] = useDefinedParams(["bookingId", "mpan", "serviceLine", "contractId"]);
    const nav = useNavigate();
    const location = useLocation();
    const state = location.state as {
        bookingData?: getBookingSuccessType;
        activeMopAppointment?: boolean;
    }

    const bookingData = state?.bookingData;
    const activeMopAppointment = state?.activeMopAppointment;

    //Store booking data in global state
    if(bookingData != undefined) {
        useStoreBooking().storeSite(bookingData);
    }

    if(bookingData == undefined) {
        useNav('/404', nav);
        return <span></span>
    }

    const isJobRebookable = bookingData.Status === "Cancelled" && useCanAccess('canRebook') === true && bookingData.JobTypeCode != undefined && activeMopAppointment != false;

    return (
        <div id="jbp-job-screen" className="mx-10 mt-6">
            <div className="flex flex-row justify-end mb-4 gap-4">
                {bookingData.IsCancellable === true && useCanAccess('canCancelBooking') === true && (
                    <CancelJobButton bookingId={bookingId} mpan={mpan} serviceLine={serviceLine} />
                )}
                {bookingData.IsEditable === true && useCanAccess('canEditBooking') === true && (
                    <EditJob bookingId={bookingId} mpan={mpan} contractId={contractId} serviceLine={serviceLine} booking={bookingData} />
                )}
                {isJobRebookable && (
                    <RebookJob bookingId={bookingId} mpan={mpan} serviceLine={serviceLine} booking={bookingData}></RebookJob>
                )}
            </div>
            <KeyJobDetailsCard booking={bookingData} />
            <div className="grid grid-cols-12 gap-6 mt-6 pb-10">
                <div className="col-span-6 lg:col-span-2 grid grid-cols-1 gap-6 place-content-start">
                    <SiteContactCard contactDetails={bookingData.SiteContactDetails} />
                    <UpdateDetailsCard booking={bookingData} />
                </div>
                <div className="col-span-6 lg:col-span-2 grid grid-cols-1 gap-6 place-content-start">
                    <SiteAddressCard siteAddress={bookingData.AddressDetails} />
                    <CancellationDetailsCard booking={bookingData} />
                </div>
                <div className="col-start-1 row-start-1 lg:col-start-5 col-span-full lg:col-span-8 grid grid-cols-1 gap-6 place-content-start">
                    <BookingDetailsCard booking={bookingData} />
                    <FieldDetailsCard booking={bookingData} />
                </div>
            </div>
        </div >
    )
}
